import { branch, drift, maple } from '../motifs';
import { M } from '../palette';
import { registerPlate } from '../registry';

const RED_LEAF = ['#ff8a4a', '#e0402a', '#9a2018'] as const;
const ORANGE_LEAF = ['#ffd070', '#f08a2a', '#b05418'] as const;
const GOLD_LEAF = ['#fff0a0', '#f0c040', '#b8841c'] as const;

/** 16 ใบเมเปิ้ล: the maple plate, rust red lacquer in a drift of autumn leaves. */
registerPlate({
  id: 'maple',
  name: 'ใบเมเปิ้ล',
  ground: ['#94401e', '#642614', '#40160c'],
  trim: M.gold,
  text: { fill: ['#fff0c0', '#f8c070'], line: '#1e0a04' },
  inset: [17, 14],
  front(p, f) {
    branch(
      p,
      [
        [f.x - 6, f.y + 2],
        [f.x + 4, f.y - 3],
        [f.x + 12, f.y - 6],
      ],
      1.4,
      0.6,
    );
    branch(
      p,
      [
        [f.r + 6, f.b - 2],
        [f.r - 4, f.b - 6],
        [f.r - 10, f.b - 3],
      ],
      1.4,
      0.6,
    );
    maple(p, f.x - 2, f.y + 3, 6, RED_LEAF, -0.3);
    maple(p, f.x + 7, f.y - 3, 5.5, ORANGE_LEAF, 0.2);
    maple(p, f.x + 14, f.y - 7, 4.4, RED_LEAF, 0.5);
    maple(p, f.x + 3, f.b - 3, 5.5, GOLD_LEAF, 0.6);
    maple(p, f.r - 2, f.y + 1, 5.5, ORANGE_LEAF, -0.4);
    maple(p, f.r + 4, f.b - 4, 6, RED_LEAF, 0.3);
    maple(p, f.r - 9, f.b - 1, 4.6, GOLD_LEAF, -0.6);
  },
  motion: {
    sprites: {
      leafA: { w: 5, h: 5, draw: (p) => maple(p, 2.5, 2.5, 2.4, RED_LEAF, 0) },
      leafB: { w: 5, h: 5, draw: (p) => maple(p, 2.5, 2.5, 2.4, ORANGE_LEAF, 0.6) },
    },
    play(a, t, f) {
      // Leaves tumbling: each turns between two drawings as it falls.
      const turn = Math.floor(t * 4) % 2;
      drift(a, turn ? 'leafA' : 'leafB', t, 2, f.x - 4, 14, f.y - 6, f.b + 10, { speed: 0.2, sway: 3 });
      drift(a, turn ? 'leafB' : 'leafA', t, 1, f.r - 8, 8, f.y - 4, f.b + 10, {
        speed: 0.18,
        sway: 3,
        seed: 6,
      });
    },
  },
});
